import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Checkbox } from "@mui/material";

export const DropStoreModeConfirmation = ({
  isOpen,
  onClose,
  onConfirm,
  isTurningOn,
}) => {
  const [isReady, setIsReady] = useState(false);

  const handleConfirm = () => {
    if (isReady) {
      onConfirm();
      setIsReady(false);
    }
  };

  const handleClose = () => {
    onClose();
    setIsReady(false);
  };

  if (!isOpen) return null;

  return (
    <AnimatePresence>
      {isOpen && (
        <>
          {/* Overlay */}
          <motion.div
            className="fixed inset-0 bg-[#060f23] z-30"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          />
          {/* Modal content */}
          <motion.div
            className="fixed inset-0 flex items-center justify-center z-40"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          >
            <div className="bg-[#030711] rounded-xl shadow-lg w-full max-w-[668px] max-h-[95vh] overflow-auto z-20">
              {/* Title section */}
              <div className="text-center py-10">
                <h1 className="text-[29px] font-bold text-white leading-[37px] tracking-[-0.01em] mb-2">
                  {isTurningOn
                    ? "Prepare for Drop-Store Mode"
                    : "Turn off Drop-Store Mode"}
                </h1>
                <p className="text-base font-medium text-[#C6CCE8] leading-[22px]">
                  {isTurningOn
                    ? "Ensure the processing line is setup for drop-store mode"
                    : "Turn off Drop-Store Mode"}
                </p>
              </div>

              <div className="p-8 bg-[#030711] rounded-xl">
                <h2 className="text-[20px] text-[#E6ECFF] font-bold mb-6">
                  Follow these instructions
                </h2>

                {/* Instruction with numbered bullet */}
                <div className="flex items-center gap-4 mb-6">
                  <div className="w-6 h-6 rounded-full bg-[#173991] flex-shrink-0 flex items-center justify-center">
                    <span className="text-white text-[12px] font-bold">1</span>
                  </div>
                  <p className="text-[16px] text-[#E6ECFF] leading-[22px]">
                    {isTurningOn
                      ? "Switch to the dedicated drop-store collection bins and pallets"
                      : "Switch to the mail-in collection bins and pallets"}
                  </p>
                </div>

                {/* Divider */}
                <div className="h-[1px] bg-[#282F44] mb-6" />

                {/* Confirm section */}
                <h3 className="text-[20px] text-[#E6ECFF] font-bold mb-6">
                  Confirm the processing line is ready
                </h3>

                <label className="flex items-center gap-6 cursor-pointer">
                  <Checkbox
                    checked={isReady}
                    onChange={(e) => setIsReady(e.target.checked)}
                    sx={{
                      width: 32,
                      height: 32,
                      color: "#282F44",
                      "&.Mui-checked": {
                        color: "#173991",
                      },
                      "& .MuiSvgIcon-root": {
                        fontSize: 28,
                      },
                    }}
                  />
                  <span className="text-[16px] text-[#E6ECFF] leading-[22px] select-none">
                    {isTurningOn
                      ? "The line is ready to process drop-store packages"
                      : "The line is ready to process mail-in packages"}
                  </span>
                </label>
              </div>

              {/* Bottom buttons */}
              <div className="flex gap-6 p-6">
                <button
                  onClick={handleClose}
                  className="flex-1 border-2 rounded-xl text-[21px] font-bold h-[80px] border-[#282F44] text-[#DAE3F9] bg-transparent hover:bg-[#0B1C47]"
                >
                  Cancel
                </button>
                <button
                  onClick={handleConfirm}
                  disabled={!isReady}
                  className="flex-1 rounded-xl text-[21px] font-bold h-[80px] bg-[#173991] text-white hover:bg-[#2256DB] disabled:bg-[#282F44] disabled:text-[#8086A0] disabled:cursor-not-allowed shadow-[0px_1px_2px_0px_rgba(0,0,0,0.08),inset_0px_-1px_1px_0px_rgba(0,0,0,0.16)]"
                >
                  Ok, Ready
                </button>
              </div>
            </div>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
};
